<template>
  <div>
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t(`menu.${serviceSlug}`), disabled: true },
        { title: $t('optometry.leads.title'), disabled: true }
      ]">

      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Searchable class="mr-2" :querySearch.sync="querySearch" />
        <Filters
          :isActive="showFilters"
          :activeFilters="activeFilters"
          @toggle-filters="toggleFilters" />
      </div>
    </Breadcrumbs>

    <LeadsTable
      ref="leadsTableView"
      :showFilters.sync="showFilters"
      :querySearch="querySearch"
      :customQueries="customQueries"
      @filters-updated="onFiltersUpdated"
      @leadClicked="onLeadClicked"
    />

    <LeadDetail
      v-if="showLeadDetails"
      :selectedLead="selectedLead"
      @cancel="onLeadDetailCancel"/>

  </div>
</template>
<script>
import Filters from '@/components/common/Filters'
import Searchable from '@/components/common/Searchable'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import IndexTablesMixin from '@/mixins/IndexTablesMixin'
import { TABLE_OPTOMETRY_LEADS } from '@/local-storage/LocalStorageKeys'
import LeadsTable from '@/components/optometry/leads/LeadsTable'
import LeadDetail from '@/components/optometry/leads/LeadDetail'

export default {
  props: {
    serviceSlug: {
      type: String,
      required: true
    }
  },
  components: {
    LeadDetail,
    LeadsTable,
    Filters,
    Searchable,
    Breadcrumbs
  },
  mixins: [
    IndexTablesMixin
  ],
  data () {
    return {
      selectedLead: false,
      showLeadDetails: false,
      querySearch: '',
      showFilters: false,
      activeFilters: 0,
      localStorageKey: TABLE_OPTOMETRY_LEADS,
      customQueries: null
    }
  },
  methods: {
    onLeadDetailCancel: function () {
      this.showLeadDetails = false
      this.selectedLead = null
    },
    onLeadClicked: function (selectedLead) {
      this.selectedLead = selectedLead
      this.showLeadDetails = true
    },
    onFiltersUpdated: function (activeFilters) {
      this.activeFilters = activeFilters
    },
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    }
  }
}
</script>
